module.exports = __webpack_public_path__ + "img/foot-logo.ccd91973.png";